const postal = require("common/PubSub");

function Configuration() {
    const updatesChannel = postal.channel("Configuration");
    const STORAGE_KEY = "CudaLaunch.config";

    const cachedConfig = localStorage.getObject(STORAGE_KEY) || {};

    // We don't set a default language, that will be worked out natively
    const defaultConfig = {
        loglevel : "info",
        resourceView : "icon"
    };

    this.get = function(key) {
        return cachedConfig[key] || defaultConfig[key];
    };

    this.set = function(key, val) {
        cachedConfig[key] = val;
        localStorage.setObject(STORAGE_KEY, cachedConfig);
        updatesChannel.publish(key, val);
    };
}

module.exports = new Configuration();


//////////////////
// WEBPACK FOOTER
// ./settings/Configuration.js
// module id = 64
// module chunks = 0 1 3